import React, { useState } from 'react';
import { Label, PaddingContainer } from '../styledComponents';
import Dropdown from '@/shared/components/Dropdown';
import useExploreStore from '@/stores/useExploreStore';
import { SessionType } from '@/shared/types/generated';

const VIRTUAL_SESSION_DURATIONS: { label: string; value: number }[] = [
  { label: '30 Minutes', value: 30 },
  { label: '60 Minutes', value: 60 },
];

const IN_PERSON_SESSION_DURATIONS: { label: string; value: number }[] = [
  { label: '2 Hours', value: 120 },
  { label: '3 Hours', value: 180 },
  { label: '4 Hours', value: 240 },
  { label: '5 Hours', value: 300 },
  { label: '6 Hours', value: 360 },
  { label: '7 Hours', value: 420 },
  { label: '8 Hours', value: 480 },
];

const SelectDuration = () => {
  const { booking, setBooking } = useExploreStore();
  const [isDurationMenuVisible, setIsDurationMenuVisible] = useState(false);

  const isInPersonSession =
    booking.sessionType === SessionType.InPersonSession ||
    booking.sessionType === SessionType.InPersonEvent;

  const durationOptions = isInPersonSession
    ? IN_PERSON_SESSION_DURATIONS
    : VIRTUAL_SESSION_DURATIONS;

  const getSelectedLabel = () => {
    if (isInPersonSession) {
      const hours = booking.sessionDuration / 60;
      return `${hours} Hour${hours > 1 ? 's' : ''}`;
    }
    return `${booking.sessionDuration} Minutes`;
  };

  return (
    <>
      <PaddingContainer marginBottom={24}>
        <Label>Select the duration:</Label>
      </PaddingContainer>

      <Dropdown
        eyebrowText="Duration"
        options={durationOptions}
        selectedOption={booking.sessionDuration.toString()}
        selectedOptionLabel={getSelectedLabel()}
        onSelect={(option) =>
          setBooking({ sessionDuration: Number(option.value) })
        }
        isVisible={isDurationMenuVisible}
        setIsVisible={setIsDurationMenuVisible}
      />
    </>
  );
};

export default SelectDuration;
